/**
 * Feature flags for beta launch.
 * Flip these to enable/disable features without code changes.
 */
export const featureFlags = {
  /**
   * AI chatbot / concierge — off for first release. The implementation is
   * being rebuilt; this is a release decision, not a per-environment toggle.
   */
  chatbot: false,
  /** Wishlist feature — surfaces /wishlist in the profile dropdown / burger menu. */
  wishlist: true,
  /** Show beta badge in header */
  betaBadge: true,
} as const;
